import Vue from 'vue'
import ProgressCircular from './ProgressCircular'

Vue.component('ui-progress-circular', ProgressCircular)
